import {Component, input, output, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrls: ["./sidenav.component.scss"],
})
export class SidenavComponent {
    readonly $sidenavOpen = input(false, {alias: "sidenavOpen"})
    readonly $attachToParent = input(false, {alias: "attachToParent"})
    readonly backgroundClick = output<void>()
}
